import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import './App.css';
import { getConfig } from "./configure";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router basename="/bopi">
    <App />
  </Router>
);

reportWebVitals();
